var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "url(#paint0_linear_0_774)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_774)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7254 14.2222C33.1733 14.2222 35.1653 16.2092 35.1653 18.6573C35.1653 21.1102 33.1733 23.1021 30.7254 23.1021C28.2774 23.1021 26.2854 21.1102 26.2854 18.6573C26.2854 16.2094 28.2772 14.2222 30.7254 14.2222ZM32.1748 20.5917C32.2948 20.5917 32.4195 20.5437 32.5155 20.4476L32.5155 20.4476C32.7027 20.2604 32.7027 19.958 32.5155 19.7708L31.2051 18.4604V16.6796C31.2051 16.4157 30.9891 16.1997 30.7252 16.1997C30.4564 16.1997 30.2452 16.4157 30.2452 16.6796V18.6572C30.2452 18.7868 30.2932 18.9068 30.3844 18.998L31.8341 20.4476C31.9299 20.5437 32.0501 20.5917 32.1748 20.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2852 14.6H17.6044V9.28125L12.2852 14.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2405 32.5199V24.0382C27.4901 23.7933 25.3252 21.475 25.3252 18.6577C25.3252 15.845 27.4901 13.5313 30.2405 13.2865V9.47993C30.2405 9.21596 30.0293 9 29.7605 9H18.5619V15.0815C18.5619 15.3454 18.3508 15.5614 18.082 15.5614H12V32.5201C12 32.784 12.216 33 12.4799 33H29.76C30.029 33 30.2402 32.784 30.2402 32.5201L30.2405 32.5199ZM15.2834 18.4798H24.0243C24.2882 18.4798 24.5042 18.6957 24.5042 18.9597C24.5042 19.2237 24.2882 19.4396 24.0243 19.4396L15.2834 19.4398C15.0195 19.4398 14.8035 19.2239 14.8035 18.9599C14.8035 18.6957 15.0195 18.4798 15.2834 18.4798ZM24.0243 21.5374H15.2834C15.0195 21.5374 14.8035 21.7533 14.8035 22.0175C14.8035 22.2863 15.0195 22.4974 15.2834 22.4974L24.0243 22.4972C24.2882 22.4972 24.5042 22.2861 24.5042 22.0173C24.5042 21.7533 24.2882 21.5374 24.0243 21.5374ZM14.8035 25.0797C14.8035 24.8158 15.0195 24.5998 15.2834 24.5998H24.0243C24.2882 24.5998 24.5042 24.8158 24.5042 25.0797C24.5042 25.3437 24.2882 25.5597 24.0243 25.5597L15.2834 25.5599C15.0195 25.5599 14.8035 25.3439 14.8035 25.0797ZM22.5508 30.3263L24.2309 29.9183L24.2309 29.9183C24.4901 29.8558 24.6484 29.5967 24.5813 29.3375C24.519 29.0832 24.2597 28.9198 24.0053 28.9871L22.3253 29.3952C22.0613 29.4574 21.7686 29.5199 21.6197 29.4287C21.5815 29.4045 21.5383 29.3625 21.4901 29.3158C21.4716 29.2979 21.4524 29.2793 21.4325 29.2608C21.279 29.0976 21.0582 28.8769 20.7221 28.8192C20.4582 28.7712 19.9399 28.8047 19.479 29.5392L19.4455 29.5872C19.3494 29.7455 19.2102 29.9663 19.1142 29.9856C19.0517 29.9999 18.9173 29.9424 18.7494 29.7839C18.7278 29.7647 18.7062 29.7443 18.6846 29.7239C18.663 29.7035 18.6414 29.6831 18.6198 29.664L18.6184 29.6626C18.4267 29.4711 18.211 29.2556 17.8949 29.136C17.5012 28.9873 17.0405 29.0544 16.666 29.328C16.2916 29.6016 16.0853 30.0191 16.1092 30.4416C16.1236 30.7056 16.3492 30.9073 16.6132 30.8928C16.8772 30.8783 17.0837 30.6527 17.0644 30.3887C17.0596 30.2927 17.1267 30.1822 17.2324 30.1055C17.338 30.0237 17.4628 29.9998 17.554 30.0336C17.6719 30.0789 17.794 30.1971 17.9246 30.3233C17.9322 30.3307 17.9399 30.3381 17.9476 30.3456C17.9956 30.3936 18.0436 30.4416 18.0916 30.4848C18.4757 30.8496 18.8261 30.9504 19.0949 30.9504C19.1764 30.9504 19.2532 30.941 19.3157 30.9265C19.8031 30.8176 20.0619 30.4101 20.2532 30.1089L20.2613 30.0961L20.29 30.0481C20.4292 29.8273 20.5395 29.7648 20.5588 29.7648C20.5923 29.7744 20.6884 29.8703 20.746 29.9327C20.7608 29.9468 20.7757 29.9613 20.7909 29.976C20.8846 30.0666 20.9883 30.1669 21.1205 30.2496C21.6245 30.5567 22.2053 30.4127 22.5508 30.3263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_774",
    x: 10,
    y: 9,
    width: 27.1653,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900143 0 0 0 0 0.426543 0 0 0 0 0.93504 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_774",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_774",
    x1: 50.1068,
    y1: 28.2843,
    x2: 27.6712,
    y2: -7.01942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.fddbdb89e12ac4a16b8acc36ca81d54d.svg";
export { ForwardRef as ReactComponent };